import { useState, useCallback } from 'react';
import { AgGridReact } from 'ag-grid-react';
import PaginationFooter from './PaginationFooter';

const LoadingOverlayComponent = () => {
    return (
        <span className="ag-overlay-loading-center spinner-border text-primary" style={{ width: "4rem", height: "4rem" }} role="status" />
    );
}

export default (props) => {
    const pageSize = props.pageSize ?? 12;
    const [pageNumber, setPageNumber] = useState(1);
    const [sortField, setSortField] = useState("createdDate");
    const [sortDirection, setSortDirection] = useState("desc");
    const [gridApi, setGridApi] = useState();

    const columnDefs = props.columnDefs.map(a => ({
        ...a,
        sort: a.field === sortField ? sortDirection : null,
        comparator: () => 0
    }));

    const changePage = async (newPageNumber) => {
        await props.getData(newPageNumber, pageSize, sortField, sortDirection);
        setPageNumber(newPageNumber);
    }

    //Sorting
    const onSortChanged = useCallback((event) => {
        if (event.source !== "uiColumnSorted") return;
        let column = event.columns[0];
        let sortDir = sortDirection === "desc" ? "asc" : "desc";
        //Changed sort column
        if (event.columns.length > 1) {
            column = event.columns.find(a => a.colId !== sortField);
            sortDir = "asc";
        }
        const colId = column.colId;
        props.getData(pageNumber, pageSize, colId, sortDir);
        setSortField(colId);
        setSortDirection(sortDir);
    });

    //Pagination
    const onPaginationChanged = async (params) => {
        if (!gridApi || !params.newPage) return;
        const currentPage = gridApi.paginationGetCurrentPage() + 1;
        await props.getData(currentPage, pageSize, sortField, sortDirection);
        setPageNumber(currentPage);
    };

    const onGridReady = useCallback(({ api }) => {
        setGridApi(api);
    });

    return (
        <div className="custom-pagination">
            <AgGridReact
                {...props}
                columnDefs={columnDefs}
                pagination={true}
                domLayout='autoHeight'
                paginationPageSize={pageSize}
                paginationAutoPageSize={false}
                serverSideEnableClientSideSort={true}
                loadingOverlayComponent={LoadingOverlayComponent}
                suppressPaginationPanel={true}
                onSortChanged={onSortChanged}
                onPaginationChanged={onPaginationChanged}
                onGridReady={onGridReady}
            />
            <PaginationFooter
                pageNumber={pageNumber}
                pageSize={pageSize}
                totalRows={props.totalRows}
                changePage={changePage}
            />
        </div>
    );
}